
import { Options, Vue } from "vue-class-component";
import SearchBar from "@/components/SearchBar.vue";
import Logo from "@/components/Logo.vue";
import UserStatus from "@/components/UserStatus.vue";
import TitleList from "@/components/TitleList.vue";

@Options({
  components: {
    SearchBar,
    Logo,
    UserStatus,
    TitleList,
  },
  props: {},
  watch: {
    "$store.state.solApp"() {
      this.getTitles();
    },
  },
})
export default class Profile extends Vue {
  titles = [];
  ens = "";
  address = "Loading Address...";
  loading = false;
  profile = null;

  mounted(): void {
    this.load();
  }

  load(): void {
    if (this.loading) return;
    this.loading = true;
    this.getTitles();
    this.getProfile();
  }

  get isOwner(): boolean {
    return this.$store.state.ensName === this.ens + ".eth";
  }

  async getTitles(): Promise<void> {
    const ens = this.$route.params.id;
    if (!ens) return;
    this.ens = (ens as string).toLowerCase().replace(".eth", "");
    this.loading = true;
    this.titles = await this.$store.state.solApp?.getTitles(this.ens);
    this.loading = false;
    this.address = await this.$store.state.ens
      ?.name(this.ens + ".eth")
      .getAddress();
    if (this.address == "0x0000000000000000000000000000000000000000") {
      this.address = "Account not found";
    }
  }

  async getProfile(): Promise<void> {
    const res = await fetch(
      `https://cors-where.herokuapp.com/http://43.130.232.102:8080/q?ens=${this.ens}.eth`
    );
    const profile = await res.json();
    console.log(profile);
    if (profile?.status === 0) {
      this.profile = profile.data;
    }
  }
}
